import { Box, Typography } from '@mui/material';
import clsx from 'clsx';
import { EMPTY_VALUE_INDICATOR, isNotNullValue } from 'framework/utils';
import { FieldLayoutProps } from '../../field';
import { fieldWrapperSx } from 'framework/ui/styles';

const IconFieldLayout = ({ label, value, className }: FieldLayoutProps) => {
  return (
    <Box className={clsx('field__wrapper', className)} display="flex" alignItems="center" sx={fieldWrapperSx}>
      {label as any}
      <Typography variant="body1" component="div">
        {isNotNullValue(value) ? value : EMPTY_VALUE_INDICATOR}
      </Typography>
    </Box>
  );
};

export default IconFieldLayout;
